// https://gist.github.com/maranomynet/78096cd5f5a5a72348bc  (classifyelementsizefactory)
import classifyElementSizeFactory from "./classifyelementsizefactory";

const iframeIntervalMs = 200;
const inlineIntervalMs = 300;


export default function (widget) {
    const sizemonitor = {};
    const env = widget.env;

    let _isMonitoring = false;
    let _heightMonitor;
    let _widthMonitor;
    let _formatCallbacks = [];
    let _triggeringCallbacks = false;

    let sizeChecker;
    const monitorContainerSize = function () {
        const state = sizeChecker.check(env.containerElm);
        sizemonitor.state = state;
        if (state.changed) {
            // console.log( 'New main format:', state.is );
            // console.log( 'Active formats:', state.active );
            _triggeringCallbacks = true;
            for (let i = 0, callback; (callback = _formatCallbacks[i]); i++) {
                callback(state);
            }
            _triggeringCallbacks = false;
        }
    };

    sizemonitor.state = {};

    sizemonitor.on = function (callback) {
        if (callback) {
            // sizemonitor.off(callback);
            _formatCallbacks.push(callback);
            // run callbacks immediately if .start()
            if (_isMonitoring && !_triggeringCallbacks) {
                callback(sizemonitor.state);
            }
        }
    };
    // sizemonitor.off = function (callback) {
    //     for (let i=0, cb; (cb = _formatCallbacks[i]); i++)
    //     {
    //       if ( cb === callback )
    //       {
    //         _formatCallbacks.splice(i,1);
    //         break;
    //       }
    //     }
    //   },


    sizemonitor.start = function () {
        if (!_isMonitoring) {
            _isMonitoring = true;
            // Monitor the widget width and set classes and trigger events...
            sizeChecker = sizeChecker || classifyElementSizeFactory(widget.mediaFormats, {
                    bemName: widget.wrapperClass,
                    bemModifier: 'size',
                });
            if (env.iframe) {
                env.window.addEventListener('resize', monitorContainerSize);
            }
            else {
                _widthMonitor = setInterval(monitorContainerSize, inlineIntervalMs);
            }
            monitorContainerSize();

            // Height:auto for <iframe>
            if (env.iframe) {
                const iframe = env.iframe;
                const iframeBody = env.document.body;
                const checkIframe = function () {
                    // const height = iframeBody.scrollHeight || 0;
                    const height = (iframeBody.firstChild || {}).scrollHeight || 0;
                    if (iframe._lastHeight !== height) {
                        iframe._lastHeight = height;
                        iframe.style.height = height + 'px';
                    }
                    // _checkMaxHeight(iframe);
                };
                _heightMonitor = setInterval(checkIframe, iframeIntervalMs);
                checkIframe();
            }
        }
    };


    sizemonitor.stop = function () {
        if (_isMonitoring) {
            _isMonitoring = false;
            if (env.iframe) {
                env.window.removeEventListener('resize', monitorContainerSize);
                clearInterval(_heightMonitor);
            }
            else {
                clearInterval(_widthMonitor);
            }
        }
        _formatCallbacks = [];
    };

    return sizemonitor;
}
